function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Find the closest selected row to the newly selected row
 * @param row - newly selected row
 * @param rows - currently selected rows
 */
const findClosestPreviousRow = (row, rows) => {
  let minDistance = Infinity;
  let minIndex = 0;
  let i = 0;
  const rowsInView = rows.filter(r => r.index >= 0);

  // initialize minIndex to the first row in view
  if (rowsInView !== null && rowsInView !== void 0 && rowsInView.length) {
    minIndex = rows.indexOf(rowsInView[0]);
  }
  while (i < rows.length && rows[i].index < row.index) {
    const currDistance = rows[i].index >= 0 ? Math.abs(rows[i].index - row.index) : Infinity;
    if (currDistance < minDistance) {
      minIndex = i;
      minDistance = currDistance;
    } else {
      break;
    }
    i++;
  }
  return rows[minIndex];
};

/**
 * Remap index property in each row to account for sorting using allRows order
 * @param row - newly selected row
 * @param selectedRows - currently selected rows
 * @param allRows - all rows in the table
 */
const remapTableIndices = (row, selectedRows, allRows) => {
  const newRow = _objectSpread({}, row);
  const newSelectedRows = [...selectedRows];
  const newAllRows = [...allRows];
  newRow.index = allRows.findIndex(r => r.index === row.index);
  newSelectedRows.forEach(r => {
    r.index = allRows.findIndex(row => row.id === r.id);
  });
  for (let i = 0; i < allRows.length; i++) {
    newAllRows[i].index = i;
  }
  return {
    mappedRow: newRow,
    mappedSelectedRows: newSelectedRows,
    mappedAllRows: newAllRows
  };
};
export const getMultiRowRangeSelection = (row, selectedRows, allRows) => {
  // remap row indices to account for sorting
  const {
    mappedRow,
    mappedSelectedRows,
    mappedAllRows
  } = remapTableIndices(row, selectedRows, allRows);
  const prevRow = findClosestPreviousRow(mappedRow, mappedSelectedRows);
  if (!prevRow) return {};
  // if the closest row is not visible then just select the current row
  if (prevRow.index < 0) return {
    [row.id]: true
  };
  let firstRow = prevRow;
  let lastRow = mappedRow;
  let inc = 1;

  // user is selecting in reverse order so swap variables
  if (row.index < prevRow.index) {
    firstRow = mappedRow;
    lastRow = prevRow;
    inc = 0;
  }
  return Array.from({
    length: Math.abs(lastRow.index - firstRow.index)
  }).reduce((accum, _, index) => {
    const nextRow = mappedAllRows.find(r => r.index === index + inc + firstRow.index);
    if (nextRow) return _objectSpread(_objectSpread({}, accum), {}, {
      [nextRow.id]: true
    });
    return accum;
  }, {});
};
export const getDisableHighlightOnMouseDown = _ref => {
  let {
    enableMultiRowRangeSelection,
    selectedRows
  } = _ref;
  if (!enableMultiRowRangeSelection) {
    return undefined;
  }
  return e => {
    if (e !== null && e !== void 0 && e.shiftKey && selectedRows.length) {
      e.preventDefault();
    }
  };
};
//# sourceMappingURL=getMultiRowRangeSelection.js.map